<template>
  <validation-observer ref="simpleRules" #default="{ invalid }">
    <b-form class="auth-register-form" @submit.prevent="change">
      <b-form-group
        label="رمز عبور قبلی"
        label-for="reset-password-new"
        v-if="!$route.params.id"
      >
        <validation-provider
          #default="{ errors }"
          name="oldPassword"
          vid="oldPassword"
          rules="required|min:6|password|notArabic"
        >
          <b-input-group
            class="input-group-merge"
            :class="errors.length > 0 ? 'is-invalid' : null"
          >
            <b-form-input
              autocomplete="on"
              id="change-old-password"
              v-model="oPassword"
              :type="password3FieldType"
              :state="errors.length > 0 ? false : null"
              class="form-control-merge"
              name="change-old-password"
              placeholder="············"
            />
            <b-input-group-append is-text>
              <feather-icon
                class="cursor-pointer"
                :icon="password3ToggleIcon"
                @click="togglePassword3Visibility"
              />
            </b-input-group-append>
          </b-input-group>
          <small class="text-danger">{{ errors[0] }}</small>
        </validation-provider>
      </b-form-group>
      <b-form-group label="رمز عبور جدید" label-for="reset-password-new">
        <validation-provider
          #default="{ errors }"
          name="Password"
          vid="Password"
          :rules="`required|min:6|password|notArabic|oldpassword:${oPassword}`"
        >
          <b-input-group
            class="input-group-merge"
            :class="errors.length > 0 ? 'is-invalid' : null"
          >
            <b-form-input
              autocomplete="on"
              id="reset-password-new"
              v-model.trim="password"
              :type="password1FieldType"
              :state="errors.length > 0 ? false : null"
              class="form-control-merge"
              name="reset-password-new"
              placeholder="············"
            />
            <b-input-group-append is-text>
              <feather-icon
                class="cursor-pointer"
                :icon="password1ToggleIcon"
                @click="togglePassword1Visibility"
              />
            </b-input-group-append>
          </b-input-group>
          <small class="text-danger">{{ errors[0] }}</small>
        </validation-provider>
      </b-form-group>

      <b-form-group
        label-for="reset-password-confirm"
        label=" تایید رمز عبور جدید"
      >
        <validation-provider
          #default="{ errors }"
          name="Confirm Password"
          :rules="`required|min:6|password|notArabic|confirmed:${password}|oldpassword:${oPassword}`"
        >
          <b-input-group
            class="input-group-merge"
            :class="errors.length > 0 ? 'is-invalid' : null"
          >
            <b-form-input
              autocomplete="on"
              id="reset-password-confirm"
              v-model.trim="cPassword"
              :type="password2FieldType"
              class="form-control-merge"
              :state="errors.length > 0 ? false : null"
              name="reset-password-confirm"
              placeholder="············"
            />
            <b-input-group-append is-text>
              <feather-icon
                class="cursor-pointer"
                :icon="password2ToggleIcon"
                @click="togglePassword2Visibility"
              />
            </b-input-group-append>
          </b-input-group>
          <small class="text-danger">{{ errors[0] }}</small>
        </validation-provider>
      </b-form-group>

      <b-button
        :variant="$route.path.includes('users') ? 'info' : 'primary'"
        block
        type="submit"
        :disabled="invalid"
      >
        تغییر رمز عبور
      </b-button>
    </b-form>
    <loader :loading="loading" />
  </validation-observer>
</template>

<script>
import {
  BButton,
  BForm,
  BFormCheckbox,
  BFormGroup,
  BFormInput,
  BInputGroup,
  BInputGroupAppend,
  BImg,
  BCardTitle,
  BAlert,
  BLink,
} from "bootstrap-vue";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required, notArabic } from "@validations";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import Loader from "@/@core/components/loader/Loader.vue";
export default {
  components: {
    BButton,
    BAlert,
    ValidationObserver,
    ValidationProvider,
    BLink,
    BForm,
    BFormCheckbox,
    BFormGroup,
    BFormInput,
    BInputGroup,
    BInputGroupAppend,
    BImg,
    BCardTitle,
    Loader,
  },
  data() {
    return {
      required,
      notArabic,
      oPassword: "",
      cPassword: "",
      password: "",
      loading: false,
      password1FieldType: "password",
      password2FieldType: "password",
      password3FieldType: "password",
    };
  },
  watch: {
    oPassword(val) {
      this.oPassword = this.p2e(val);
    },
    password(val) {
      this.password = this.p2e(val);
    },
    cPassword(val) {
      this.cPassword = this.p2e(val);
    },
  },
  computed: {
    passwordToggleIcon() {
      return this.passwordFieldType === "password" ? "EyeIcon" : "EyeOffIcon";
    },
    password1ToggleIcon() {
      return this.password1FieldType === "password" ? "EyeIcon" : "EyeOffIcon";
    },
    password2ToggleIcon() {
      return this.password2FieldType === "password" ? "EyeIcon" : "EyeOffIcon";
    },
    password3ToggleIcon() {
      return this.password3FieldType === "password" ? "EyeIcon" : "EyeOffIcon";
    },
  },

  methods: {
    togglePassword1Visibility() {
      this.password1FieldType =
        this.password1FieldType === "password" ? "text" : "password";
    },
    togglePassword2Visibility() {
      this.password2FieldType =
        this.password2FieldType === "password" ? "text" : "password";
    },
    togglePassword3Visibility() {
      this.password3FieldType =
        this.password3FieldType === "password" ? "text" : "password";
    },
    async change() {
      this.$refs.simpleRules.validate().then(async (success) => {
        if (success) {
          this.loading = true;
          try {
            if (this.$route.params.id) {
              const { data } = await this.$http.patch(
                `/panel/users/${this.$route.params.id}/change-password`,
                {
                  password: this.password,
                  password_confirmation: this.cPassword,
                }
              );
            } else {
              const { data } = await this.$http.patch(
                "/panel/profile/password",
                {
                  current_password: this.oPassword,
                  password: this.password,
                  password_confirmation: this.cPassword,
                }
              );
            }

            this.loading = false;
            this.$toast(
              {
                component: ToastificationContent,
                props: {
                  title: "رمز عبور با موفقیت تغییر یافت",
                  icon: "CheckIcon",
                  variant: "success",
                },
              },
              { position: "bottom-right" }
            );
          } catch (err) {
            this.loading = false;
          }
        }
      });
    },
  },
};
</script>

<style></style>
